module.exports = __webpack_public_path__ + "img/image.13971236.png";